import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Statistic, Table, Modal, Tabs } from "antd";
import { CustomSpinner } from "../utils/CustomComponents";
import FranchiseSellerMonthWeekByPsi from "./FranchiseSellerMonthWeekByPsi";
import FranchiseSellerMonthDayByPsi from "./FranchiseSellerMonthDayByPsi";

const { Text } = Typography;

const FranchiseSellerYardsPerPsi = ({ sellerId, plant }) => {
	const [loading, setLoading] = useState(false);
	const [loadingTable, setLoadingTable] = useState(false);
	const [jobList, setJobList] = useState([]);
	const [modalWeekOpen, setModalWeekOpen] = useState(false);
	const month = useRef(null);
	const psiId = useRef(null);
	const psi = useRef(null);

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "PSI",
			dataIndex: "psi",
			key: "psi",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Jan",
			dataIndex: "1",
			key: "1",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										month.current = "1";
										psiId.current = values.psiId;
										psi.current = values.psi;
										setModalWeekOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Feb",
			dataIndex: "2",
			key: "2",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										month.current = "2";
										psiId.current = values.psiId;
										psi.current = values.psi;
										setModalWeekOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Mar",
			dataIndex: "3",
			key: "3",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										month.current = "3";
										psiId.current = values.psiId;
										psi.current = values.psi;
										setModalWeekOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Apr",
			dataIndex: "4",
			key: "4",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										month.current = "4";
										psiId.current = values.psiId;
										psi.current = values.psi;
										setModalWeekOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "May",
			dataIndex: "5",
			key: "5",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										month.current = "5";
										psiId.current = values.psiId;
										psi.current = values.psi;
										setModalWeekOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Jun",
			dataIndex: "6",
			key: "6",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										month.current = "6";
										psiId.current = values.psiId;
										psi.current = values.psi;
										setModalWeekOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Jul",
			dataIndex: "7",
			key: "7",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										month.current = "7";
										psiId.current = values.psiId;
										psi.current = values.psi;
										setModalWeekOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Aug",
			dataIndex: "8",
			key: "8",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										month.current = "8";
										psiId.current = values.psiId;
										psi.current = values.psi;
										setModalWeekOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Sep",
			dataIndex: "9",
			key: "9",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										month.current = "9";
										psiId.current = values.psiId;
										psi.current = values.psi;
										setModalWeekOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Oct",
			dataIndex: "10",
			key: "10",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										month.current = "10";
										psiId.current = values.psiId;
										psi.current = values.psi;
										setModalWeekOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Nov",
			dataIndex: "11",
			key: "11",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										month.current = "11";
										psiId.current = values.psiId;
										psi.current = values.psi;
										setModalWeekOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
		{
			title: "Dec",
			dataIndex: "12",
			key: "12",
			render: (value, values) => {
				return (
					<div
						onClick={
							value
								? () => {
										month.current = "12";
										psiId.current = values.psiId;
										psi.current = values.psi;
										setModalWeekOpen(true);
								  }
								: null
						}
						style={{ cursor: value ? "pointer" : "default" }}
					>
						<Statistic
							value={value}
							valueStyle={{
								fontSize: 14,
							}}
							suffix={value ? "yards" : ""}
						/>
					</div>
				);
			},
		},
	];

	useEffect(() => {
		const getJobs = async () => {
			try {
				setLoading(true);

				const url = api + `/job/seller/psi/yards/${sellerId}/${plant}`;

				const token = localStorage.getItem("token");
				axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

				const { data } = await axios.get(url);

				const groupedSellers = data.payload
					.filter(
						(i) => i.psi !== null && i.psi !== undefined && i.psiName !== ""
					)
					.reduce((acc, item) => {
						if (!acc[`${item.psiName}_${item.psi._id}`]) {
							acc[`${item.psiName}_${item.psi._id}`] = [];
						}
						acc[`${item.psiName}_${item.psi._id}`].push(item);
						return acc;
					}, {});

				const newRows = Object.entries(groupedSellers).map(([key, values]) => {
					const keyPairs = key.split("_");
					let obj = {
						psi: keyPairs[0],
						psiId: keyPairs[1],
					};
					values.map((item) => {
						obj[`${item.month}`] = item.totalYards;
					});

					return obj;
				});

				setJobList(newRows);
				setLoading(false);
				setLoadingTable(false);
			} catch (err) {
				console.error(err.message);
				return null;
			}
		};

		getJobs();
	}, [sellerId]);

	const RenderTable = () => {
		return (
			<Table
				columns={columns}
				dataSource={jobList}
				loading={loadingTable}
				pagination={false}
			/>
		);
	};

	const getMonth = (month) => {
		let monthName = "";
		switch (month) {
			case "1":
				monthName = "January";
				break;
			case "2":
				monthName = "February";
				break;
			case "3":
				monthName = "March";
				break;
			case "4":
				monthName = "April";
				break;
			case "5":
				monthName = "May";
				break;
			case "6":
				monthName = "June";
				break;
			case "7":
				monthName = "July";
				break;
			case "8":
				monthName = "August";
				break;
			case "9":
				monthName = "September";
				break;
			case "10":
				monthName = "October";
				break;
			case "11":
				monthName = "November";
				break;
			case "12":
				monthName = "December";
				break;
			default:
				monthName = "Invalid";
				break;
		}
		return monthName;
	};

	const RenderModalSellerMonthWeek = () => {
		let currentTab = "weeks";
		const items = [
			{
				key: "weeks",
				label: "Weeks",
				children: (
					<FranchiseSellerMonthWeekByPsi
						sellerId={sellerId}
						month={month.current}
						psiId={psiId.current}
						psi={psi.current}
						plant={plant}
					/>
				),
			},
			{
				key: "days",
				label: "Days",
				children: (
					<FranchiseSellerMonthDayByPsi
						sellerId={sellerId}
						month={month.current}
						psiId={psiId.current}
						psi={psi.current}
						plant={plant}
					/>
				),
			},
		];

		const onChange = (key) => {
			currentTab = key;
		};

		return (
			<Modal
				title={`Month ${getMonth(month.current)}`}
				open={modalWeekOpen}
				onCancel={() => setModalWeekOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={800}
			>
				<Tabs defaultActiveKey={currentTab} items={items} onChange={onChange} />
			</Modal>
		);
	};

	return (
		<Flex vertical gap={"large"}>
			{loading ? <CustomSpinner /> : <RenderTable />}
			<RenderModalSellerMonthWeek />
		</Flex>
	);
};

export default FranchiseSellerYardsPerPsi;
